import React from "react";
import { Helmet } from 'react-helmet-async';

const PermitsPage = () => (
    <>
        <Helmet>
            <title>Strandskydd & bygglov</title>
        </Helmet>
        <div>
            <h1>Strandskydd & bygglov</h1>
            <p>Innehåll kommer visas här</p>
        </div>
    </>
);

export default PermitsPage;
